import React from 'react';

export default function DateChart() {
    return (
        <div>
           Date chart
        </div>
    )
}
